var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _path9, _line2, _path10, _path11, _line3, _line4, _circle2, _path12, _path13, _polygon, _path14, _g, _rect, _rect2, _g2, _rect3, _line5, _path15, _path16, _path17, _g3, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path18, _path19, _line6, _line7, _line8, _line9, _line10, _line11, _line12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efe1b4;}.cls-2{fill:#baa875;}.cls-3{fill:#fff;}.cls-11,.cls-15,.cls-16,.cls-4,.cls-5,.cls-6{fill:none;}.cls-4{stroke:#efe1b4;}.cls-11,.cls-15,.cls-16,.cls-4,.cls-5{stroke-linecap:round;stroke-width:4px;}.cls-15,.cls-16,.cls-4,.cls-5,.cls-6{stroke-miterlimit:10;}.cls-5{stroke:#baa875;}.cls-6{stroke:#fff;stroke-linecap:square;stroke-width:2px;}.cls-7{fill:#997c64;}.cls-8{fill:#a7e8ea;opacity:0.51;}.cls-9{opacity:0.77;}.cls-10{fill:#a3bfbd;}.cls-11{stroke:#a3bfbd;stroke-linejoin:round;}.cls-12{fill:#f4d13d;opacity:0.52;}.cls-13{fill:#f4efb0;}.cls-14{fill:#dbd786;}.cls-15{stroke:#b2aa44;}.cls-16{stroke:#8c8762;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64,
    cy: 66,
    r: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.57,72.3l-.13-.29S106.65,56,69.85,93.75c1.17,8.4,7.2,14.34,11.47,19.5a106.1,106.1,0,0,1,7.56,10.06A63,63,0,0,0,127.57,72.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46,24a9.94,9.94,0,0,0-4.29,1A16,16,0,0,0,10,28c0,.09,0,.18,0,.26A8,8,0,1,0,8,44H46a10,10,0,0,0,0-20Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46,19a9.94,9.94,0,0,0-4.29,1A16,16,0,0,0,10,23c0,.09,0,.18,0,.26A8,8,0,1,0,8,39H46a10,10,0,0,0,0-20Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.34,112.28c-3.22-8.61-7.65-12.19-8.8-20.68a32.06,32.06,0,0,1-.18-5.84C30,61.54,12.9,69.24,5,76.94A60,60,0,0,0,73.18,125.3,37.71,37.71,0,0,0,70.34,112.28Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M17.19,93A247.17,247.17,0,0,1,30.65,124"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.21,76.38a283.84,283.84,0,0,1,16.11,31.7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.48,76.38a270.72,270.72,0,0,1,18.87,39.56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52.14,89.74a270.89,270.89,0,0,1,13.17,27.76"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 16.7,
    x2: 16.7,
    y1: 72.7,
    y2: 54.63
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.61,46.79c0,6.94-2.65,7.39-5.91,7.39s-5.91-.45-5.91-7.39S13.43,25,16.7,25,22.61,39.85,22.61,46.79Z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 30.82,
    x2: 30.82,
    y1: 77.64,
    y2: 62.57
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.73,54.73c0,6.94-2.65,7.39-5.91,7.39s-5.91-.45-5.91-7.39,2.65-21.79,5.91-21.79S36.73,47.8,36.73,54.73Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106,46a9.94,9.94,0,0,0-4.29,1A16,16,0,0,0,70,50c0,.09,0,.18,0,.26A8,8,0,1,0,68,66h38a10,10,0,0,0,0-20Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 39,
    x2: 49,
    y1: 49,
    y2: 49
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 44,
    x2: 44,
    y1: 54,
    y2: 44
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 52,
    cy: 9,
    r: 5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.12,71.88A3,3,0,0,0,109,74h0a3,3,0,0,0-5.12-2.12A2.86,2.86,0,0,0,104,76l5,6,5-6A2.86,2.86,0,0,0,114.12,71.88Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106,41a9.94,9.94,0,0,0-4.29,1A16,16,0,0,0,70,45c0,.09,0,.18,0,.26A8,8,0,1,0,68,61h38a10,10,0,0,0,0-20Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "74 27 66 27 65 10 65 0 74 0 83 0 83 10 82 27 74 27"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M82,14c0,28,6.82,33,6.82,33C103.95,62.08,106,79.55,106,86c0,24-16,34-16,34H58S42,110,42,86c0-6.45,2.05-23.92,17.18-39,0,0,6.82-5,6.82-33"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.2,64a59.22,59.22,0,0,1,11-15S75,44,75,16h7c0-.66,0-1.32,0-2H66c0,28-6.82,33-6.82,33a59,59,0,0,0-12,17Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    height: 8,
    rx: 4,
    ry: 4,
    width: 36,
    x: 56,
    y: 120
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    height: 8,
    rx: 4,
    ry: 4,
    width: 22,
    x: 63,
    y: 6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73,10H85a4,4,0,0,0-4-4H67a4,4,0,0,0,0,8h2A4,4,0,0,1,73,10Z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    height: 8,
    rx: 4,
    ry: 4,
    width: 22,
    x: 63,
    y: 6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 64,
    x2: 84,
    y1: 21,
    y2: 21
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M100.78,64a59,59,0,0,0-12-17S82,42,82,14"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M66,14c0,28-6.82,33-6.82,33a59,59,0,0,0-12,17"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M47.22,64A54.36,54.36,0,0,0,42,86c0,24,16,34,16,34H90s16-10,16-34a54.36,54.36,0,0,0-5.22-22Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54,105s-3-10.24-3-17a54.88,54.88,0,0,1,6.2-24h-10q-.82,1.76-1.47,3.46l0,.1q-.3.79-.58,1.57l0,.12C44.51,70.9,44,72.49,43.65,74l0,.11q-.18.7-.33,1.38l0,.12c-.32,1.44-.57,2.79-.75,4l0,.21q-.07.52-.14,1l0,.19c-.09.76-.16,1.48-.21,2.14v.21c0,.25,0,.49,0,.72v.28c0,.21,0,.41,0,.6s0,.16,0,.23c0,.26,0,.51,0,.74,0,12.67,4.46,21.43,8.67,26.89C57.46,111.94,54,105,54,105Z"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 94,
    cy: 76,
    r: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 67,
    cy: 92,
    r: 3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 71,
    cy: 108,
    r: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 87,
    cy: 108,
    r: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 78,
    cy: 74,
    r: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 97,
    cy: 97,
    r: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 61,
    cy: 79,
    r: 2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 54,
    cy: 99,
    r: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M47.22,64A54.36,54.36,0,0,0,42,86c0,24,16,34,16,34H90s16-10,16-34a54.36,54.36,0,0,0-5.22-22Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M86,75s-5,27-18,40"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 81.41,
    x2: 92,
    y1: 91.44,
    y2: 82
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 79.67,
    x2: 90,
    y1: 96,
    y2: 93
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 77,
    x2: 87,
    y1: 101.89,
    y2: 99
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 81,
    x2: 78,
    y1: 90,
    y2: 80
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 78.46,
    x2: 76,
    y1: 97.41,
    y2: 88
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 71,
    x2: 75,
    y1: 94,
    y2: 104
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 84,
    x2: 83,
    y1: 80,
    y2: 71
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d0d0a39daab8b3cf2a2ef7ceb0337d31.svg";
export { ForwardRef as ReactComponent };